export default __webpack_public_path__ + "static/media/button-checkbox-off.f255e53b.svg";